import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TOK_PAYMENT } from 'src/app/constants/route.constants';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';
import { UserService } from '../user/user.service';

/**
 * Keeps B21K keepers on their current step's page: TOK details, then TOK payment.
 * Every other flow is let through.
 */
export const b21kGuard: CanActivateFn = (
  route,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const flowService = inject(RegistrationFlowService);
  const userService = inject(UserService);
  const router = inject(Router);

  return flowService.loadSteps().pipe(
    switchMap((): Observable<boolean | UrlTree> => {
      const flowRoute = flowService.getB21KRoute();
      // Path only: the TOK payment URL carries the pet name in the query string
      if (!flowRoute || flowRoute === state.url.split('?')[0]) {
        return of(true);
      }
      if (flowRoute !== `/${TOK_PAYMENT}`) {
        return of(router.createUrlTree([flowRoute]));
      }
      // The cached steps can still be on payment once the keeper has paid, until the backend catches
      // up. Their TOK request is closed by then, and the payment page would only send them on.
      return userService.getMe().pipe(
        map((user) => user.tokRequests.length === 0 || router.createUrlTree([flowRoute])),
        catchError(() => of(true))
      );
    })
  );
};
